import React from "react";

const NotFound = (props) => {
  return <div>404 Not Found</div>;
};

export default NotFound;
